import { BluPayApiError } from "../../api/client";
import { safeApiErrorMessage } from "../../utils/safeApiErrorMessage";
import { format } from "./messages";

/**
 * Shows a customer-safe error: what happened, what to do next, and a
 * reference support can look up.
 *
 * `error` is a BluPayApiError, a string the screen wrote itself, or anything
 * else, which falls back to `fallback`.
 */
export function ErrorNotice({
  error,
  fallback = "We couldn't complete your request.",
  onRetry,
}) {
  if (!error) {
    return null;
  }

  const apiError = error instanceof BluPayApiError ? error : null;
  const message =
    typeof error === "string" ? error : safeApiErrorMessage(error, fallback);

  return (
    <div
      role="alert"
      className="rounded-2xl bg-red-50 border border-red-100 p-4 text-red-500 text-sm space-y-1"
    >
      <p>{message}</p>

      {apiError?.action && <p className="text-red-400">{apiError.action}</p>}

      {apiError?.requestId && (
        <p className="text-[11px] text-red-300">
          {format("error_notice.reference", { request_id: apiError.requestId })}
        </p>
      )}

      {apiError?.retryable && onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-1 text-sm font-semibold text-red-600 underline underline-offset-2"
        >
          {format("error_notice.retry")}
        </button>
      )}
    </div>
  );
}
